import { useEffect } from 'react';
import useGeoLocation from '@api/hooks/useGeoLocation';
import useLoginStore from '@stores/login/loginStore';
import {
  getOTPDataCleaner,
  getOTPSender,
  getResetVerifyOtpResponse
} from '@stores/selectors/login';
import constants from '@cont/Login/constants';
import useCountryInitializer from './useCountryInitializer';
import useLocalEmailAndName from './useLocalEmailAndName';

const useLoginInitializer = ({
  country,
  setCountry,
  mobileNumber,
  userInfo,
  fieldsData,
  setFieldsData,
  setNumberStepErrorMsg,
  setStep
}) => {
  const { geoLocationData: { countryCode } = {} } = useGeoLocation();
  const { localEmailAddress, localName } = useLocalEmailAndName();
  const sendOtpOrEmail = useLoginStore(getOTPSender);
  const resetOtpResponse = useLoginStore(getOTPDataCleaner);
  const resetVerifyOtpResponse = useLoginStore(getResetVerifyOtpResponse);

  useEffect(() => {
    const selectedCountryCode = country?.code || countryCode || 'IN';
    if (mobileNumber) {
      sendOtpOrEmail({
        phone: mobileNumber,
        countryCode: selectedCountryCode,
        otpType: 1,
        email: userInfo?.email || ''
      }).then((verifyUserResult) => {
        if (verifyUserResult) {
          const { is_partial_user, is_registered, error, has_email, has_name } =
            verifyUserResult;
          if (error) {
            setNumberStepErrorMsg(error.message);
            return;
          }
          if (!is_registered && country.ageGroups?.length > 0) {
            setStep(constants.CONFIRM_AGE);
          } else if (
            !has_email &&
            !has_name &&
            ((!is_partial_user && !is_registered) ||
              (is_partial_user && is_registered))
          ) {
            // not registered user or partially registered user
            setStep(constants.ENTER_OTP_UNREGISTERED_USER_STEP);
          } else {
            // registered user
            setStep(constants.ENTER_OTP_STEP);
          }
        }
      });
    }

    return () => {
      resetOtpResponse();
      resetVerifyOtpResponse();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (localEmailAddress || localName) {
      const formData = { ...fieldsData };
      formData.email.value = localEmailAddress;
      formData.name.value = localName;
      setFieldsData(formData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localEmailAddress, localName, setFieldsData]);

  useCountryInitializer({ setCountry });
};

export default useLoginInitializer;
